// Ten Outs — third decoy. Cycling preset words; the magician hands the
// phone to the spectator with the screen facing the magician. Words
// rotate every TENOUTS_INTERVAL seconds. When the spectator flips the
// phone toward themselves (detected via `deviceorientation` heading
// crossing a 90° threshold), the current word is locked and revealed.

import { STORAGE } from "./storage";

const DEFAULT_INTERVAL_SEC = 4;
const MIN_INTERVAL_SEC = 2;
const MAX_INTERVAL_SEC = 10;

/** Built-in starter list. Magician can edit any/all of these in Settings. */
export const DEFAULT_TENOUTS_WORDS = [
  "love", "trust", "fear", "money", "family",
  "freedom", "truth", "hope", "secret", "future",
];

/** Read the full Ten-Outs configuration in one shot. */
export function getTenOutsConfig() {
  let words;
  try {
    const raw = localStorage.getItem(STORAGE.TENOUTS_WORDS);
    const arr = raw ? JSON.parse(raw) : null;
    words = Array.isArray(arr) ? arr.map((w) => String(w || "")) : null;
  } catch {
    words = null;
  }
  if (!words || words.length === 0) words = [...DEFAULT_TENOUTS_WORDS];
  // Pad to 10 with blanks so the cycle always has exactly 10 slots.
  while (words.length < 10) words.push("");
  if (words.length > 10) words = words.slice(0, 10);

  const intRaw = parseInt(localStorage.getItem(STORAGE.TENOUTS_INTERVAL) || "", 10);
  const interval = Number.isFinite(intRaw)
    ? Math.max(MIN_INTERVAL_SEC, Math.min(MAX_INTERVAL_SEC, intRaw))
    : DEFAULT_INTERVAL_SEC;

  const template =
    localStorage.getItem(STORAGE.TENOUTS_TEMPLATE) ||
    "I knew you would say (xxx).";

  return {
    enabled: localStorage.getItem(STORAGE.TENOUTS_ENABLED) === "1",
    interval,                 // seconds per word
    template,                 // contains (xxx) placeholder
    words,                    // length === 10
  };
}

export function saveTenOutsWords(words) {
  const arr = Array.isArray(words) ? words.slice(0, 10).map((w) => String(w || "")) : [];
  while (arr.length < 10) arr.push("");
  localStorage.setItem(STORAGE.TENOUTS_WORDS, JSON.stringify(arr));
}

export function saveTenOutsInterval(seconds) {
  const n = Math.max(
    MIN_INTERVAL_SEC,
    Math.min(MAX_INTERVAL_SEC, parseInt(seconds, 10) || DEFAULT_INTERVAL_SEC)
  );
  localStorage.setItem(STORAGE.TENOUTS_INTERVAL, String(n));
}

export function setTenOutsLocked(word) {
  if (word) localStorage.setItem(STORAGE.TENOUTS_LOCKED, String(word));
  else      localStorage.removeItem(STORAGE.TENOUTS_LOCKED);
}

export function readTenOutsLocked() {
  return localStorage.getItem(STORAGE.TENOUTS_LOCKED) || "";
}

export function clearTenOutsLocked() {
  localStorage.removeItem(STORAGE.TENOUTS_LOCKED);
}

/** Substitute (xxx) in the template with `word`. If no placeholder, append the word. */
export function formatTenOuts(template, word) {
  const w = String(word || "").trim();
  if (!w) return "";
  const tpl = String(template || "").trim();
  if (!tpl) return w;
  if (/\(xxx\)/.test(tpl)) return tpl.replace(/\(xxx\)/g, w);
  return `${tpl} ${w}`;
}

export { MIN_INTERVAL_SEC, MAX_INTERVAL_SEC, DEFAULT_INTERVAL_SEC };
